import React from "react";
import { cn } from "@/lib/utils";

/**
 * A small keyboard-key hint badge, e.g. <Kbd>N</Kbd>.
 */
const Kbd: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => (
  <kbd
    className={cn(
      "inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded border border-border bg-muted px-1.5 font-mono text-[10px] font-semibold uppercase leading-none text-muted-foreground",
      className,
    )}
  >
    {children}
  </kbd>
);

export default Kbd;